var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideoSearchResult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#004F71",
    d: "M20 37c9.389 0 17-7.611 17-17S29.389 3 20 3 3 10.611 3 20s7.611 17 17 17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#33728D",
    d: "M20 7.13c7.11 0 12.87 5.76 12.87 12.87 0 7.11-5.76 12.87-12.87 12.87"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.7,
    d: "m26.53 18.27-8.52-4.92c-1.33-.77-3 .19-3 1.73v9.84c0 1.54 1.67 2.5 3 1.73l8.52-4.92c1.33-.77 1.33-2.69 0-3.46v0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSearchResult);
export default __webpack_public_path__ + "static/media/VideoSearchResult.ae4999a94d7b7fe4b496ffa2c26142f6.svg";
export { ForwardRef as ReactComponent };